import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/sass/style.scss';

import AOS from 'aos';
import 'aos/dist/aos.css';

import "react-tooltip/dist/react-tooltip.css";

import "@fontsource/raleway";
import "@fontsource/raleway/100.css";
import "@fontsource/raleway/200.css";
import "@fontsource/raleway/300.css";
import "@fontsource/raleway/400.css";
import "@fontsource/raleway/500.css";
import "@fontsource/raleway/600.css";
import "@fontsource/raleway/700.css";
import "@fontsource/raleway/800.css";
import "@fontsource/raleway/900.css";
import "@fontsource/raleway/100-italic.css";
import "@fontsource/raleway/200-italic.css";
import "@fontsource/raleway/300-italic.css";
import "@fontsource/raleway/400-italic.css";
import "@fontsource/raleway/500-italic.css";
import "@fontsource/raleway/600-italic.css";
import "@fontsource/raleway/700-italic.css";
import "@fontsource/raleway/800-italic.css";
import "@fontsource/raleway/900-italic.css";

import { Route, Routes, useLocation } from 'react-router-dom';
import { routes } from './routes/Routes';
import Header from './components/Header';
import Footer from './components/Footer';
import { useEffect } from 'react';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import EnquiryForm from './components/EnquiryForm';

function App() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      once: true, // Whether animation should happen only once while scrolling down
      offset: 50,
    });
  }, []);

  return (
    <div className='overflow-hidden'>
      <Header />
      <Routes>
        {
          routes.map((item, index) => {
            return (
              <Route path={item?.path} element={item?.element} key={index} />
            )
          })
        }
      </Routes>
      <Footer />
      <EnquiryForm />
    </div>
  );
}

export default App;
